import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import FontSize from '../FontSize';
import Color from '../Color';

const rawTheme = createTheme({
  palette: {
    primary: {
      light: Color.Main,
      main: Color.Main,
      dark: Color.Main,
    },
    secondary: {
      light: Color.Sub,
      main: Color.Sub,
      dark: Color.Sub,
    },
    warning: {
      main: Color.Warning,
      dark: Color.Warning
    },
    error: {
      light: Color.Error,
      main: Color.Error,
      dark:  Color.Error,
    },
    success: {
      light: Color.Main,
      main: Color.Main,
      dark: Color.Main,
    },
    blue: {
      main: Color.Sub,
    }
  },
  typography: {
    fontFamily: "'Asap', normal",
    fontSize: 14,
    fontWeightLight: 500,
    fontWeightRegular: 600,
    fontWeightMedium: 700,
  },
});

const fontHeader = {
  color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  fontFamily: "'Asap', normal",
  textTransform: 'uppercase',
};

const fontNormal = {
  color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  fontFamily: "'Asap', normal",
};

const theme = {
  ...rawTheme,
  palette: {
    ...rawTheme.palette,
    background: {
      ...rawTheme.palette.background,
      default: rawTheme.palette.common.white,
      placeholder: grey[200],
    },
  },
  typography: {
    ...rawTheme.typography,
    fontHeader,
    h1: {
      ...rawTheme.typography.h1,
      ...fontHeader,
      letterSpacing: 0,
      fontSize: FontSize.Gigantic,
    },
    h2: {
      ...rawTheme.typography.h2,
      ...fontHeader,
      fontSize: FontSize.Huge,
    },
    h3: {
      ...rawTheme.typography.h3,
      ...fontNormal,
      fontSize: FontSize.Large,
    },
    h4: {
      ...rawTheme.typography.h4,
      ...fontNormal,
      fontSize: FontSize.Big,
    },
    h5: {
      ...rawTheme.typography.h5,
      fontSize: FontSize.Normal,
      fontWeight: rawTheme.typography.fontWeightLight,
    },
    h6: {
      ...rawTheme.typography.h6,
      ...fontNormal,
      fontSize: FontSize.Medium,
    },
    subtitle1: {
      ...rawTheme.typography.subtitle1,
      ...fontNormal,
      fontSize: FontSize.Small,
    },
    body1: {
      ...rawTheme.typography.body1,
      ...fontNormal,
      fontSize: FontSize.Small,
      fontWeight: rawTheme.typography.fontWeightRegular,
    },
    body2: {
      ...rawTheme.typography.body2,
      fontSize: FontSize.Small,
      fontWeight: rawTheme.typography.fontWeightLight,
    },
    body3: {
      ...rawTheme.typography.body2,
      fontSize: FontSize.Tiny,
      fontWeight: rawTheme.typography.fontWeightLight,
    },
  },
};

export default theme;